export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "engineWater.worker.2607ce0b4915809de49d-engineWater.worker.worker.js");
}
